

export default {
  // 공지사항
  noticeList: {
    // current_page:0, // 현재페이지
    // data: [], // 실제데이터
    // first_page_url:'', // 처음페이지 주소
    // last_page_url:'', // 마지막페이지 주소
    // next_page_url:'', // 다음페이지
    // prev_page_url:'', // 이전페이지
    // from:0, // 게시글 시작번호
    // to:0, // 게시글 마지막번호
    // total:0, // 총 게시글수
    // per_page:0, // 페이지당 게시글
    // last_page:0, // 마지막페이지
  },

  noticeContent: {
    // author: []
    // board_id
    // created_at
    // updated_at
    // id
    // post_is_secret
    // post_parent_id
    // post_thumbnail_id
    // post_title
    // post_content
    // post_count_view
    // user_name
  }


}
